import { Component } from '@angular/core';
import { ModalComponent } from '@appShared/components/modal/modal.component';
import { StockListComponent } from './stock-list.component';

@Component({
  template: `
    <app-modal title="Stock Pricing" [showFooter]="false">
      <app-stock-list></app-stock-list>
    </app-modal>`,
   imports: [ModalComponent, StockListComponent]
})
export class StockListModalComponent {
  constructor() {}
}
